var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome",class:{hide:_vm.hide}},[_c('img',{attrs:{"src":"/images/welcome.jpg","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }